export default "__VITE_ASSET__BipAZ4RK__"